module.exports = __webpack_public_path__ + "static/media/diaspora_icon.24382684.svg";